import { Injector } from '@angular/core';

/*
The purpose of this is to be able to access the injector from unusual spots,
notably the decorators. It is structured this way in order to avoid dependency
issues. This has very few dependencies, and actually relies of the timing of
the system startup to be safe.
*/

let appInjectorRef: Injector;
export const appInjector = (injector?: Injector): Injector => {
    if (injector) {
        appInjectorRef = injector;
    }

    return appInjectorRef;
};
